import React from "react";
import { NavLink } from "react-router-dom";
import { HiUserGroup } from "react-icons/hi";
import { BiBuildingHouse } from "react-icons/bi";
import { PanelRightClose, PanelRightOpen, UserRoundPlus } from "lucide-react";

const sidebarItems = [
  {
    to: "/onevasco/branch",
    icon: BiBuildingHouse,
    text: "Branch",
  },
  {
    to: "/onevasco/create_member",
    icon: UserRoundPlus,
    text: "Create Member",
  },
  {
    to: "/onevasco/memberlist",
    icon: HiUserGroup,
    text: "Member List",
  },
];

const SidebarLink = ({ to, icon: Icon, text, collapsed }) => {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          `
            group relative flex items-center gap-3 px-3 py-2 font-Roboto text-base rounded-lg
            transition-all duration-300
            ${
              isActive
                ? collapsed
                  ? "bg-[#FCDD00] text-black rounded-full w-[50px] h-[50px] flex items-center justify-center"
                  : "bg-[#FCDD00] text-black"
                : collapsed
                ? "text-[#1A1A1A] rounded-full w-[50px] h-[50px] flex items-center justify-center hover:bg-gray-100"
                : "text-[#1A1A1A] hover:bg-gray-100"
            }
          `
        }
      >
        <span className="text-xl">
          <Icon />
        </span>
        {!collapsed && text}
        {collapsed && (
          <span
            className="fixed left-[80px] rounded-md bg-black text-white text-sm px-2 py-1 
                              opacity-0 group-hover:opacity-100 whitespace-nowrap z-[9999] pointer-events-none"
          >
            <div className="absolute top-1/2 translate-y-[-50%] -left-1 w-2 h-2 bg-black transform rotate-45"></div>
            {text}
          </span>
        )}
      </NavLink>
    </li>
  );
};

const VfsOneVascoSidebar = ({ collapsed, setCollapsed }) => {
  return (
    <div
      className={`flex flex-col transition-all duration-300 bg-white  
  ${collapsed ? "w-[80px] overflow-hidden justify-center" : "w-[200px]  justify-between"}`}
    >
      <div className="min-w-[200px] bg-white  flex-col justify-between flex">
        <div className={`px-3 py-3 flex flex-col  justify-center gap-2  text-xl relative group`}>
          <button
            onClick={() => setCollapsed((prevState) => !prevState)}
            className={`text-[#1A1A1A] rounded-lg  w-[50px] h-[50px] flex items-center justify-center hover:bg-gray-100 `}
          >
            {!collapsed && <PanelRightClose className="w-[20px] h-[20px] " />}
            {collapsed && <PanelRightOpen className="w-[20px] h-[20px]" />}
          </button>
          
  {/* Tooltip */}
    <span
            className="fixed left-[80px] rounded-md bg-black text-white text-sm px-2 py-1
                      opacity-0 group-hover:opacity-100 whitespace-nowrap z-[9999] pointer-events-none"
          >
            <div className="absolute top-1/2 translate-y-[-50%] -left-1 w-2 h-2 bg-black transform rotate-45"></div>
    {collapsed ? "Show" : "Hide"}
  </span>
        </div>
        <div>
          <ul className="px-3 flex flex-col gap-2 min-w-[200px]">
            {sidebarItems.map((item, index) => (
              <SidebarLink
                key={index}
                to={item.to}
                icon={item.icon}
                text={item.text}
                collapsed={collapsed}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VfsOneVascoSidebar;